export const default_alert_indexes = ["sisbo", "sisprocep", "siapen", "sic", "pmpimobile"]